import {
  fetchPostCheckoutChargeWithRetry,
} from "apps/website/utils/fetch-post-checkout-charge";

import { TrackerContext } from "../../types";
import { SourceHandler } from "../types";

export const getPostCheckoutChargesHandler: SourceHandler = async (
  api,
  context: TrackerContext,
  setter,
) => {
  console.log("in getPostCheckoutChargesHandler");
  if (context.sources.getPostCheckoutCharges !== undefined) {
    console.log("getpostCheckoutCharges source exists! ");
    return;
  }

  if (!api.tokenStatus.accessToken) {
    console.log("Access token not available, skipping getPostCheckoutCharges");
    return;
  }

  const res = await fetchPostCheckoutChargeWithRetry(api);

  if (res) {
    setter((old) => ({ ...old, getPostCheckoutCharges: res }));
  }
};
